import { Command } from '@/app/common/base/command'

export class SubmitKnowledgeFormCommand extends Command {
    public async run(answers: { [key: string]: string }, productActionId: string) {
        await this.client.post('/api/knowledge-form', { answers, productActionId })
    }
}
